// extracted by mini-css-extract-plugin
export default {"container":"L7Ev7","thumbnail":"j7kri","overlay":"yWYm7","button":"Wjt44","arrow":"LxxnH","icon":"djz44"};